<template>
  <div>


    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>

    <b-modal v-model="model.show" size="xl"  id="modalPopover" :title="model.title" hide-footer>
      <vue-load-image style="text-align:center">
        <img
                slot="image"
                :src="model.src"
                style="border-radius: 0.25rem;max-width:100%"
        />
        <div
                slot="preloader"
                class="image-loading-container"
                style="width:100%;height:100px"
        >
          <div>
            <b-spinner label="Loading..."></b-spinner><br />Loading..
          </div>
        </div>
        <div slot="error" class="screenshot-error" >
          <p></p>
          <h4>Image Error.</h4>
          <p>
            If this problem persists<br> please let us know.
          </p>
          <i class="fa fa-warning"></i>
        </div>
      </vue-load-image>

    </b-modal>
    <h1 class="page-title">Page Details</h1>
    <change-viewer :options="changeViewer"></change-viewer>

    <div v-if="loading" class="page-loading-container">
      <b-spinner label="Loading..." ></b-spinner>
    </div>

    <div v-else>
      <div v-if="!(this.dataLoaded || this.scanStatus.completed)" class="page-loading-container">
        <b-spinner label="Loading..." ></b-spinner>
      </div>
      <div v-else>
    <b-row>
      <b-col lg="8">
        <div class="pb-xlg h-100">
          <Widget class="h-100 mb-0" :title="page.title" :updating="pageUpdating(page)">
            <a :href="page.url" target="_blank" v-b-tooltip.hover title="External Link">{{page.url}}</a>
          </Widget>
        </div>
      </b-col>
      <b-col lg="4">
        <div class="pb-xlg h-100">
          <Widget class="h-100 mb-0">
            <div v-if="pageUpdating(page)">
              <b-alert size="sm" show variant="secondary" class="mt-2" >
                <b-spinner label="Loading..." style="width:16px;height:16px"></b-spinner>&nbsp; Audit in progress
              </b-alert>
            </div>
            <div v-else>
              <div class="text-muted d-flex flex-wrap mt-0">
                <small class="mr-lg d-flex align-items-center">Last Check: {{page.crawl_date | moment('from')}}</small>
              <div class="mt-2" v-if="user.role !== 'readonly'">
                <b-button size="sm"  @click="recheck" variant="info" >
                Check Again</b-button>
              </div>
              </div>
            </div>
          </Widget>
        </div>
      </b-col>
    </b-row>
        <b-row>
          <b-col>
            <div class="pb-xlg" style="height:188px">
            <Widget class="h-100 mb-0" title="Page Updates" :updating="pageUpdating(page)" :fetchingData="trends.history.categories.length === 0">
            <div v-if="trends.history.categories.length > 0" :key="dataLoaded.history">
              <heat-graph  @clickEvent="clickEvent" :emitEvent="true" :pad="0" :height="90" :options="trends.history"></heat-graph>
            </div>
            </Widget>
            </div>
          </b-col>
        </b-row>
      <b-row>
        <b-col lg="7">
          <div class="pb-xlg h-100">
            <Widget class="h-100 mb-0" title="Performance" :updating="pageUpdating(page)">
              <div v-if="crawlVersion > 0">
                <div v-if="(page.lighthouse_report && page.lighthouse_report.status === 'error')">
                  <b-alert show variant="warning">Lighthouse report could not be generated.</b-alert>
                </div>
                <div v-else>
                  <div v-if="page.lighthouse_report && page.lighthouse_report.ready">
                    <a class="lighthouse-report-link" :href="reportUrl(page)" target="_blank" v-b-tooltip.hover title="View Original Lighthouse Report">View Report</a>
                  </div>
                <p></p>
                <b-container class="bv-example-row mt-4">

                <div class="table-responsive graph-container">
                  <table class="table align-middle table-sm" :key="dataLoaded.history">
                    <thead></thead>
                    <tbody>
                    <tr>
                      <td  class="align-middle" width="60%"> Performance Score</td>
                      <td class="align-middle" width="35%">
                        <div v-if="trends.performance.length > 0">
                          <spark-line :pad="pad" :rails="[49, 89, 100]" :data="trends.performance" title="Performance"></spark-line>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div v-if="trends.performance.length > 0">
                          <b-badge :variant="badgeRailsVariant(trends.performance[trends.performance.length-1].data, [49, 89])"> {{trends.performance[trends.performance.length-1].data}}</b-badge>
                        </div>
                        <div v-else>
                          <b-spinner title="Generating latest report..." style="width:16px;height:16px;color:gray"></b-spinner>
                        </div>

                      </td>
                    </tr>
                    <tr>
                      <td  class="align-middle"> Time To Interactive</td>
                      <td class="align-middle">
                        <div v-if="trends.interactive.length > 0">
                          <spark-line :pad="pad" units="ms" :rails="[3800, 7300]" :inverse="true" :data="trends.interactive"  title="Time To Interactive"></spark-line>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div v-if="trends.interactive.length > 0">
                        <b-badge :variant="badgeRailsVariant(trends.interactive[trends.interactive.length-1].data, [3800, 7300], true)">
                          {{trends.interactive[trends.interactive.length-1].data | number}}ms
                        </b-badge>
                        </div>

                      </td>
                    </tr>
                    <tr>
                      <td  class="align-middle"> First Contentful Paint</td>
                      <td class="align-middle">
                        <div v-if="trends.first_contentful_paint.length > 0">
                          <spark-line :pad="pad" units="ms" :rails="[2000, 4000]" :inverse="true" :data="trends.first_contentful_paint"  title="First Contentful Paint"></spark-line>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div v-if="trends.first_contentful_paint.length > 0">
                        <b-badge :variant="badgeRailsVariant(trends.first_contentful_paint[trends.first_contentful_paint.length-1].data, [2000, 4000], true)">
                          {{trends.first_contentful_paint[trends.first_contentful_paint.length-1].data | number}}ms
                        </b-badge>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td  class="align-middle"> Cumulative Layout Shift</td>
                      <td class="align-middle">
                        <div v-if="trends.cumulative_layout_shift.length > 0">
                          <spark-line :pad="pad" :rails="[0.1, 0.25]" :inverse="true" :data="trends.cumulative_layout_shift"  title="Cumulative Layout Shift"></spark-line>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div v-if="trends.cumulative_layout_shift.length > 0">
                        <b-badge :variant="badgeRailsVariant(trends.cumulative_layout_shift[trends.cumulative_layout_shift.length-1].data, [0.1, 0.25], true)">
                          {{trends.cumulative_layout_shift[trends.cumulative_layout_shift.length-1].data | number('0.00')}}
                        </b-badge>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td  class="align-middle"> Page Weight</td>
                      <td class="align-middle">
                        <div v-if="trends.page_weight.length > 0">
                          <spark-line :pad="pad" :data="trends.page_weight" units="size" title="Page Weight"></spark-line>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div v-if="trends.page_weight.length > 0">
                        <b-badge :variant="badgeRailsVariant(trends.page_weight[trends.page_weight.length-1].data, [1200*1024, 1600*1024], true)">
                          {{trends.page_weight[trends.page_weight.length-1].data | bytes}}
                        </b-badge>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                </b-container>
                </div>
              </div>
              <div v-else>
                <span style="color:gray">This report was generated with an older version of pagewatch.</span>
              </div>
            </Widget>
          </div>
        </b-col>
        <b-col lg="5">
          <div class="pb-xlg h-100">
            <Widget class="h-100 mb-0" title="Latest Audit" :updating="pageUpdating(page)">
              <div class="table-responsive graph-container mt-4">
                <table class="table align-middle table-sm" >
                  <thead></thead>
                  <tbody>
                  <tr>
                    <td  class="align-middle"> Layout Errors</td>

                    <td class="align-middle">
                      <b-badge variant="success">No Issues</b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td  class="align-middle"> Broken Links</td>
                    <td class="align-middle">
                      <b-badge v-if="page.websites_link_pages_aggregate.aggregate.count > 0" variant="warning">{{page.websites_link_pages_aggregate.aggregate.count}} Issues</b-badge>
                      <b-badge v-else variant="success">No Issues</b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td  class="align-middle"> Broken Resources</td>
                    <td class="align-middle">
                      <b-badge v-if="page.broken_resources.aggregate.count > 0" variant="warning">{{page.broken_resources.aggregate.count}} Issues</b-badge>
                      <b-badge v-else variant="success">No Issues</b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td  class="align-middle"> Javascript Errors</td>
                    <td class="align-middle">
                    <b-badge v-if="page.js_errors.aggregate.count > 0" variant="warning">{{page.js_errors.aggregate.count}} Errors</b-badge>
                    <b-badge v-else variant="success">No Issues</b-badge>
                    </td>
                  </tr>
                  <tr>
                    <td  class="align-middle"> Spelling Mistakes</td>
                    <td class="align-middle">
                      <b-badge v-if="page.websites_spellingerror_pages_aggregate.aggregate.count > 0" variant="warning">{{page.websites_spellingerror_pages_aggregate.aggregate.count}} Issues</b-badge>
                      <b-badge v-else variant="success">No Issues</b-badge>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </Widget>
          </div>
        </b-col>
      </b-row>
    <b-row>
      <b-col lg="12">

        <Widget class="h-100 mb-0" title="Latest Screenshots" :updating="pageUpdating(page)">
    <div class="scroll-container">
      <table>
        <tbody>
        <tr>
          <td v-for="(screenshot, screenshotIndex) in screenshots" style="padding:.5em 0.4em">


              <div :style="`position:relative;height:${Math.round(screenshot.deviceDetails.mockup.inner_size.width * screenshot.deviceDetails.viewport.height / screenshot.deviceDetails.viewport.width)+50}px`">
                <img v-if="screenshot.deviceDetails.mockup.image"
                     :src="`/${screenshot.deviceDetails.mockup.image}.png`"
                     :width="screenshot.deviceDetails.mockup.size.width"
                     :style="`position:relative;top:${screenshot.deviceDetails.mockup.size.top}px;left:${screenshot.deviceDetails.mockup.size.left-10}px`"
                     class="desktop-preview"

                />
                <a title="View Full Screenshot"  @click="showModel(`${screenshot.deviceDetails.platform} (${screenshot.deviceDetails.viewport.width}x${screenshot.deviceDetails.viewport.height})`, screenshot.screenshotFull.url)" :style="`position:absolute;left:${screenshot.deviceDetails.mockup.inner_size.left-10}px;top:${screenshot.deviceDetails.mockup.inner_size.top}px;border-radius:2px`">

                <vue-load-image>
                <img
                        slot="image"
                        :width="screenshot.deviceDetails.mockup.inner_size.width"
                        :src="`${screenshot.screenshot.url}?tr=w-${screenshot.deviceDetails.mockup.inner_size.width}`"
                        style="border-radius: 0.25rem;"
                />
                <div
                        slot="preloader"
                        class="image-loading-container"
                        :style="`width:${screenshot.deviceDetails.mockup.inner_size.width}px;height:200px;`"
                >
                  <div>
                    <b-spinner label="Loading..."></b-spinner><br />Loading..
                  </div>
                </div>
                  <div slot="error" class="screenshot-error" :style="{width: screenshot.deviceDetails.mockup.inner_size.width+'px', height: Math.round(screenshot.deviceDetails.mockup.inner_size.width * screenshot.deviceDetails.viewport.height / screenshot.deviceDetails.viewport.width) +'px'}">
                    <p></p>
                    <h4>Image Error.</h4>
                    <p>
                      If this problem persists<br> please let us know.
                    </p>
                    <i class="fa fa-warning"></i>
                  </div>
              </vue-load-image>
                </a>
              </div>
              <div style="padding-top:40px;">

              </div>

          </td>
        </tr>
        </tbody>
      </table>


</div>
        </Widget>
      </b-col>
    </b-row>
      </div>
  </div>
  </div>

</template>

<script>
import Widget from '@/components/Widget/Widget';
import DemoNotice from "@/components/DemoNotice/DemoNotice";
import HeatGraph from "@/components/TrendGraph/HeatGraph";
import SparkLine from "@/components/TrendGraph/SparkLine";
import ChangeViewer from "@/components/ChangeViewer/ChangeViewer";

import axios from "axios";
import gql from "graphql-tag";
import { mapState } from 'vuex';
import VueLoadImage from 'vue-load-image'

export default {
  name: 'Dashboard',
  components: { Widget, ChangeViewer, 'vue-load-image': VueLoadImage, DemoNotice, HeatGraph, SparkLine },
  apollo: {
    $subscribe: {
      history: {
        query() {
          return gql`subscription {
                history:websites_website(where: {id: {_eq: ${this.activeSite.id}},  websites_crawls:{websites_crawledpages: {path: {_eq: "${this.pageUrl}"}}}}) {
                id
                url
                uuid
                crawl_history: websites_crawls(where: {status: {_eq: "completed"}, websites_crawledpages: {path: {_eq: "${this.pageUrl}"}}}, order_by: {completed_at: asc}, limit: 21){
                  id
                  external_reference
                  pull_request
                  completed_at
                  started_at
                  websites_crawledpages(where: {ready: {_eq: true}, path: {_eq: "${this.pageUrl}"}},  limit: 1) {
                      id
                      crawl_date
                      path
                      websites_diffs(where: {ready: {_eq: true}, type: {_eq: 17}, websites_devicerender:{device_id:{_eq:"chrome"}}}){
                          id
                          ratio
                          type
                      }
                      websites_devicerenders(where: {device_id: {_eq: "galaxy_s6"}}){
                        id
                        websites_lighthousereport{
                          id
                          device_render_id
                          ready
                          status
                          seo
                          performance
                          first_contentful_paint
                          largest_contentful_paint
                          first_cpu_idle
                          first_meaningful_paint
                          interactive
                          cumulative_layout_shift
                          speed_index
                          total_blocking_time
                          best_practices
                          accessibility
                          interactive
                          network_slowest_request
                          network_largest_request
                          page_weight
                        }
                      }
                  }
                }
              }
            }`
        },
        result(data){
          let website = data.data.history[0];
          this.trends = {
            history: {
              series:[
                {name: 'Visual', data:[]}
              ],
              categories: [],
              categoryParams: [],
            },
            performance: [],
            interactive: [],
            largest_contentful_paint: [],
            cumulative_layout_shift: [],
            network_slowest_request: [],
            network_largest_request: [],
            first_contentful_paint: [],
            page_weight: [],
          };
          this.history = [];

          for (let history of website.crawl_history){
            this.trends.history.categories.push(history.websites_crawledpages[0].crawl_date);
            this.trends.history.categoryParams.push({id: history.websites_crawledpages[0].id, path: history.websites_crawledpages[0].path});
            this.trends.history.series[0].data.push((history.websites_crawledpages[0].websites_diffs[0] || {}).ratio || 0);


            if (!history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport){
              continue
            }
            this.history.push(history.id)
            this.trends.performance.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.performance,
            });
            this.trends.interactive.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.interactive,
            });
            this.trends.largest_contentful_paint.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.largest_contentful_paint,
            });
            this.trends.cumulative_layout_shift.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.cumulative_layout_shift,
            });
            this.trends.first_contentful_paint.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.first_contentful_paint,
            });
            this.trends.network_slowest_request.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.network_slowest_request,
            });
            this.trends.network_largest_request.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.network_largest_request,
            });
            this.trends.page_weight.push({
              timestamp: history.started_at,
              data: history.websites_crawledpages[0].websites_devicerenders[0].websites_lighthousereport.page_weight,
            });

          }
          this.dataLoaded.history += 1;
          // this.trends.history.reverse();
        },
        skip(){
          return !(this.page.id) || (this.dataLoaded.history && this.scanStatus.completed);
        }
      },
      websites_website: {
        query() {
          return gql`subscription {
            websites_website(where: {id: {_eq: ${this.activeSite.id}},  websites_crawls:{websites_crawledpages: {path: {_eq: "${this.pageUrl}"}}}}) {
              id
              url
              uuid
              websites_crawledpages(where: {ready: {_eq: true}, is_latest: {_eq: true}, path: {_eq: "${this.pageUrl}"}},  limit: 1) {
                title
                id
                crawl_date
                level
                url
                path
                websites_devicerenders{
                  id
                  device_id
                  screenshots
                  layout_errors_count
                  websites_lighthousereport{
                    id
                    device_render_id
                    ready
                    status
                  }
                }
                websites_link_pages_aggregate(where: {websites_link: {is_broken: {_eq: true}}}){
                  aggregate{
                    count
                  }
                }
                broken_images:websites_brokenresource_pages_aggregate(where: {websites_brokenresource: {resource_type: {_in: ["image"]}}}){
                  aggregate{
                    count
                  }
                }
                broken_resources:websites_brokenresource_pages_aggregate(where: {websites_brokenresource:{resource_type: {_in: ["js", "other"]}}}){
                  aggregate{
                    count
                  }
                }
                js_errors:websites_consolelog_pages_aggregate(where: {websites_consolelog:{type: {_in: ["error"]}}}){
                  aggregate{
                    count
                  }
                }
                websites_vulnerability_pages_aggregate{
                  aggregate{
                    count
                  }
                }
                websites_spellingerror_pages_aggregate(where:{websites_spellingerror:{active: {_eq: true}}}){
                  aggregate{
                    count
                  }
                }
              }

            }
          }`
        },
        skip () {
          return !(this.activeSite.id) || (this.dataLoaded.websites_website && this.scanStatus.completed);
        },
        result (data) {
          this.pageCount = 0;
          this.numberOfPages = 1;
          this.screenshots = [];
          if ((data.data.websites_website && data.data.websites_website.length)) {
            this.website = data.data.websites_website[0];
            this.crawlVersion = 2;

            this.page = data.data.websites_website[0].websites_crawledpages[0];
            if (!this.page){
              this.$router.push({ name: "Dashboard" });
              return;
            }
            this.page.layout_errors_count = 0;
            for(let deviceDetails of this.page.websites_devicerenders){
                this.page.layout_errors_count += deviceDetails.layout_errors_count;
                this.screenshots.push({
                  deviceDetails: this.activeSite.devices.filter((d) => {return  d.id === deviceDetails.device_id })[0],
                  screenshot: deviceDetails.screenshots.main.screenshot,
                  screenshotFull: deviceDetails.screenshots.full.screenshot,
                });
              if (deviceDetails.websites_lighthousereport && deviceDetails.websites_lighthousereport.ready) {
                this.page.lighthouse_report = deviceDetails.websites_lighthousereport;
              }
            }
            if (!this.page.lighthouse_report && this.scanStatus.completed){
              this.page.lighthouse_report = {status: 'error'}
            }
            this.screenshots.sort( (a, b) => { return a.deviceDetails.width - b.deviceDetails.width;})

            this.lightboxItems = []
            for (let i=0; i<this.screenshots.length; i++){
              this.lightboxItems.push(this.screenshots[i].screenshotFull.url)
            }
            this.loading = false;
            this.dataLoaded.websites_website += 1;
          }
          else{
            this.$router.push({ name: "Dashboard" });
          }
        },
      },
    }
  },
  data() {
    return {
      pages: [],
      pad: 0,
      changeViewer: {
        show: false,
        page: 0,
        path: ''
      },
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      website:{},
      history: [],
      trends:{
        history: {
          series:[
            {name: 'History', data:[]}
          ],
          categories: [],
        },
        performance: [],
        interactive: [],
        largest_contentful_paint: [],
        first_contentful_paint: [],
        cumulative_layout_shift: [],
        network_slowest_request: [],
        network_largest_request: [],
        page_weight: [],
      },
      breadcrumbs: [
              {
        text: 'Explore Pages',
        to: {'name': 'ExplorePage'}
      },
        {
          text: 'Details',
          active: true
        }],
      loading: true,
      dataLoaded: {
        websites_website: 0,
        history: 0,
      },
      page: {},
      screenshots: [],
      crawlVersion: 0,
      chromeScreenshot: {},
      currentPage: 1,
      pageUrl: null,
      numberOfPages: 1,
      pageCount: 1,
      lightboxIndex: null,
      model:{
        show: false,
        title: 'hello',
        src: ''
      },
      lightboxItems: [],
      pageSize: 5,
    };
  },
  methods: {
    pageUpdating(page){
      if (this.scanStatus.completed){
        return false
      }
      if (!this.scanStatus.site.crawlCompleted){
        return true;
      }
      return !!this.scanStatus.pages.find( (p)=>p.path === page.path)
    },
    badgeRailsVariant(value, rails, inverse=false){
      if (rails.length){
        if (inverse){
          if(value <= rails[0]) {
            return 'success'
          } else if (rails.length >=2 && value <= rails[1]) {
            return 'warning'
          } else {
            return 'danger'
          }
        }
        else {
          if (value <= rails[0]) {
            return 'danger'
          } else if (rails.length >= 2 && value <= rails[1]) {
            return 'warning'
          } else {
            return 'success'
          }
        }
      }
    },
    clickEvent(data){
      this.showComparison(data.id, data.path)
    },
    showComparison(page_id, path){
      this.changeViewer.path = path;
      this.changeViewer.page = page_id;
      this.changeViewer.device = 'chrome';
      this.changeViewer.show = true;
    },
    recheck(){
      const h = this.$createElement;
      const titleVNode = h('div', {domProps: {innerHTML: `This will run another check on this page.`}});
      this.$bvModal.msgBoxConfirm([titleVNode], {
        title: 'Check Again',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Continue',
        cancelTitle: 'Cancel',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
              .then(ok => {
                if (ok) {
                  axios
                          .put(`websites/recheck/${this.website.uuid}`, {scope: 'page', path: this.page.path, url: this.page.url})
                          .then(
                                  response => {
                                    this.$toast.show(`started`, 'Website Check', this.toastOptions);
                                    return true;
                                  },
                                  error => {
                                    let message = 'Unable to start check';
                                    if (error.response.data.message){
                                      message = error.response.data.message;
                                    }
                                    this.$toast.show(message, 'Error', this.toastOptions);
                                    return false;
                                  }
                          )
                }
              })

    },
    setActiveCrawl(external_reference){
      return axios
              .post(`websites/select/${external_reference}`)
              .then(
                      response => {
                        return true;
                      },
                      _response => {
                        return false;
                      }
              );
    },
    showModel(title, src){
      this.model.title = title + ' Screenshot';
      this.model.src = src+'';
      this.model.show = true;

    },
    reportUrl(page){
      return  '/lighthouse/6.0.0/?jsonurl=' + encodeURIComponent(`${axios.defaults.baseURL}lighthouse?format=json&id=${page.lighthouse_report.device_render_id}&t=${this.$auth.getToken()}`);
    },
    lighthouseColor(value, line=false){
      if (value < 50) {
        if (line) {
          return '#FF4E42';
        } else {
          return '#FFEEEC';
        }
      }
      if (value < 90) {
        if (line) {
          return '#FFA400';
        } else {
          return '#FFF6E6';
        }
      }
      if (line) {
        return '#67E0A2';
      } else {
        return '#E7FAF0';
      }
    },
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Page Details - PageWatch.dev',
    // all titles will be injected into this template
  },
  computed: {
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus", user: 'user'}),
  },
  watch: {
    'activeSite': function () {

    }
  },
  created() {
    this.$watch("$route",() => {
      this.pageUrl = this.$route.query.url || '';
      this.dataLoaded = {
        websites_website: 0,
        history: 0,
      };
      this.page = {};
    }, {
      immediate: true
    });
    this.$watch("activeSite",() => {
      this.dataLoaded = {
        websites_website: 0,
        history: 0,
      };
      this.page = {};
    }, {
      immediate: true
    });
  }
};
</script>

<style src="./PageDetails.scss" lang="scss" scoped />
<style lang="scss">
  .history_selected{
    border:3px solid #2e62ff6e;
  }
  a.lighthouse-report-link{
   position:absolute;
    top:12px;
    right:26px;
    font-size:11pt;
  }
  span.widget-loading-spinner{
    width:18px;
    height:18px;
    position:absolute;
    top:12px;
    right:12px;
    font-size:10pt;
    color:gray;
  }
</style>
